import { getLocale } from '@/src/utils/getLocale';
import React from 'react';
import './index.css';
import { reportRaptorMetrics } from '@/src/common/SLRaptor';
import { logan } from '@/src/pages/homepage/home_page_main/utils/Logan';

const Intl = Mach.requireModule('Intl');

interface Props {
  text: string;
}

interface State {
  renderChars: string[];
}

const discountTagAssets = {
  0: { src: 'assets://discount-tag/0.png', height: 18 },
  1: { src: 'assets://discount-tag/1.png', height: 18 },
  2: { src: 'assets://discount-tag/2.png', height: 18 },
  3: { src: 'assets://discount-tag/3.png', height: 18 },
  4: { src: 'assets://discount-tag/4.png', height: 18 },
  5: { src: 'assets://discount-tag/5.png', height: 18 },
  6: { src: 'assets://discount-tag/6.png', height: 18 },
  7: { src: 'assets://discount-tag/7.png', height: 18 },
  8: { src: 'assets://discount-tag/8.png', height: 18 },
  9: { src: 'assets://discount-tag/9.png', height: 18 },
  '.': { src: 'assets://discount-tag/dot.png', height: 14.5, margin: -0.1 },
  percent: { src: 'assets://discount-tag/percent.png', height: 18 },
  'ar-text': { src: 'assets://discount-tag/ar-text.png', height: 19 },
  'en-text': { src: 'assets://discount-tag/en-text.png', height: 18 },
  'zh-HK-text': { src: 'assets://discount-tag/zh-hk-text.png', height: 18.5 },
};

const reportParseResult = (result, tags = {}, loganTags = {}) => {
  reportRaptorMetrics({ ParseDiscountDescResult: result }, tags);
  logan('ParseDiscountOutlinedTag', {
    result,
    ...tags,
    ...loganTags
  });
};

export default class DiscountOutlinedTag extends React.Component<Props, State> {
  localeTemplate = {
    'zh-HK': ['numbers', 'zh-HK-text'],
    en: ['numbers', 'en-text'],
    ar: ['percent', 'numbers', 'ar-text'],
  }

  constructor(props: Props) {
    super(props);

    this.state = {
      renderChars: this.processText()
    };
  }

  componentDidUpdate(prevProps: Readonly<Props>): void {
    if (prevProps.text !== this.props.text) {
      this.setState({
        renderChars: this.processText()
      });
    }
  }

  processText() {
    const { text } = this.props;
    const locale = getLocale();
    try {
      const numberStr = `${text}`.match(/\d+(\.\d+)?/g)?.[0];
      const parsedNumber = Number(numberStr);
      if (numberStr && parsedNumber >= 0 && parsedNumber <= 100) {
        const isRTL = Intl?.isRTL?.();
        let template = [...this.localeTemplate[locale]];
        const numbers = numberStr.split('');
        template.splice(template.indexOf('numbers'), 1, ...numbers);
        template = template[isRTL ? 'reverse' : 'valueOf']() as string[];
        // 成功的case无需上报text
        reportParseResult(1, { result: 1, text: '' }, {
          msg: '折扣腰封数字解析成功✅',
          text,
          locale,
          numberStr,
          parsedNumber
        });
        return template;
      } else {
        // 失败的case上报text用于查看失败原因
        reportParseResult(0, { result: 0, text }, {
          msg: '折扣腰封解析出错❌',
          text,
          locale,
          numberStr,
          parsedNumber
        });
        return [];
      }
    } catch (e: any) {
      // 失败的case上报text用于查看失败原因
      reportParseResult(0, { result: 0, text }, {
        msg: `折扣腰封解析报错❌ 错误原因:${e?.message || 'unknown'}`,
        text,
        locale,
      });
      return [];
    }
  }

  renderTag(renderChars: string[]) {
    return renderChars.filter((char) => char in discountTagAssets).map((char, index) => {
      const charAssets = discountTagAssets[char];
      const style: React.CSSProperties = {};
      if (charAssets.margin !== undefined) {
        style.margin = `0 ${charAssets.margin}`;
      }
      if (index === 0) {
        style.marginLeft = 0;
      } else if (index === renderChars.length - 1) {
        style.marginRight = 0;
      }
      return (
        <image
          src={charAssets.src}
          style={style}
          key={index}
          resizeMode="heightFix"
          className="outlined-char"
        />
      );
    });
  }

  render() {
    const { renderChars } = this.state;
    return renderChars?.length ? (
      <view className="discount-outlined-tag">
        <view className="discount-bg" />
        { this.renderTag(renderChars) }
      </view>
    ) : null;
  }
}
